import staffStyles from '../styles/userStaffRole.module.css';

export function getStaffFrameClass(staffRole) {
  if (staffRole === 'admin') return staffStyles.staffAdmin;
  if (staffRole === 'moderator') return staffStyles.staffModerator;
  return '';
}

export function getStaffAvatarClass(staffRole) {
  if (staffRole === 'admin') return staffStyles.staffAvatarAdmin;
  if (staffRole === 'moderator') return staffStyles.staffAvatarModerator;
  return '';
}

export function getStaffRoleBadgeClass(staffRole) {
  if (staffRole === 'admin') return staffStyles.staffRoleBadgeAdmin;
  if (staffRole === 'moderator') return staffStyles.staffRoleBadgeModerator;
  return '';
}

export function getStaffRoleLabel(staffRole) {
  if (staffRole === 'admin') return 'Administrateur';
  if (staffRole === 'moderator') return 'Modérateur';
  return null;
}

export function getStaffRoleBadgeLabel(staffRole) {
  if (staffRole === 'admin') return 'Admin';
  if (staffRole === 'moderator') return 'Modérateur';
  return null;
}

export { staffStyles };
